import { React, useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import { GDPR, SecurityPolicy } from "../../../../asset/json/footer";
import "../FAQ/faq.scss";
import { Helmet } from "react-helmet";
const Security = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Security Policy" />
        <meta
          name="description"
          content="CloudSocial servers hosted in the cloud by Amazon Web Services. All the data is store in highly secure AWS data centres. Read more about CloudSocial environment."
        />
        <title>Security - Cloud Social</title>
        <link rel="canonical" href="https://cloudsocial.io/security" />
      </Helmet>
      <div className="mainContainer">
        <Container className="main">
          <div className="faqHeader">
            <h1 className="faqHeader mt-4">Security</h1>
          </div>
          {SecurityPolicy.map(({ subtitle, desc, url, note, desc1, id }) => (
            <div key={id}>
              <br />
              <div className=" faqQuestion">{subtitle}</div>
              <div className="faqAnswer">
                {desc}
                <a
                  href="mailto:support@cloudsocial.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="faqUrl"
                >
                  {url}
                </a>
              </div>
              <div className="faqAnswer">{note}</div>
              {desc1.map((data, id) => {
                return (
                  <ul key={id}>
                    <li className="faqAnswer">{data}</li>
                  </ul>
                );
              })}
            </div>
          ))}
        </Container>
      </div>
    </div>
  );
};

export default Security;
